import React from 'react';
import _ from 'lodash';
import { Link, Typography, Box } from '@mui/material';
import { BaseWidget } from 'modules/layer01';
import { LabelledText } from 'modules/layer00';
import * as dataService from './dataService';

export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);
  const shipments = queryTuple.data.shipments;

  const baseShipment = _.first(shipments);

  if (_.isEmpty(queryTuple.data.shipments) || _.isNil(shipments) || !baseShipment) {
    return null;
  }

  return _.isEmpty(shipments) ? null : (
    <BaseWidget.FC title="Tracking Information">

      <LabelledText.FC
        title="Service Code"
        text={baseShipment.serviceCode ?? 'N/A'}
      />

      <LabelledText.FC title="Tracking Numbers"
        text={
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {shipments.map((shipment, index) => (
              <React.Fragment key={index}>
                {shipment.trackingNumber ? (
                  <Link href={shipment.trackingUrl} target="_blank" sx={{ textDecoration: 'none', wordBreak: 'break-word' }}>
                    {shipment.trackingNumber}
                  </Link>
                ) : (
                  'N/A'
                )}
                {index !== shipments.length - 1 && ','} {/* Adds comma except for the last item */}
              </React.Fragment>
            ))}
          </Box>
        }
      />

      <LabelledText.FC
        title="Address"
        text={(
          <>
            <Typography>
              {baseShipment.addrLine1}
            </Typography>

            <Typography>
              {baseShipment.addrLine2}
            </Typography>

            <Typography>
              {baseShipment.addrLine3}
            </Typography>
          </>
        )} />
    </BaseWidget.FC >
  );
};
